import { t } from '@lingui/macro'
import { useLingui } from '@lingui/react'
import { Chip } from '@mui/material'
import { useParams } from 'react-router-dom'

import { PatientIdentityStatus } from '@/core/models/patient.model'
import { useIdentityStatus } from '@/entities/patient'

export function IdentityStatus() {
  useLingui()
  const { patientId } = useParams<{ patientId: string }>()

  const { identityStatus } = useIdentityStatus(patientId)

  if (!identityStatus) return null

  switch (identityStatus) {
    case PatientIdentityStatus.PROVISIONAL:
      return <Chip label={t`Identité provisoire`} color="error" size="small" />
    case PatientIdentityStatus.RECOVERED:
      return <Chip label={t`Identité récupérée`} color="info" size="small" />
    case PatientIdentityStatus.VALIDATED:
      return <Chip label={t`Identité validée`} color="secondary" size="small" />
    case PatientIdentityStatus.QUALIFIED:
      return <Chip label={t`Identité qualifiée`} color="success" size="small" />
    default:
      return null
  }
}
